import { searchPermissions } from '../constants';

const searchSharingActions = {
  ADD_SEARCH_MEMBERS: 'ADD_SEARCH_MEMBERS',
  FETCH_SEARCH_MEMBERS: 'FETCH_SEARCH_MEMBERS',
  HIDE_SHARE_SEARCH: 'HIDE_SHARE_SEARCH',
  REMOVE_SEARCH_MEMBER: 'REMOVE_SEARCH_MEMBER',
  SHARE_SEARCH: 'SHARE_SEARCH',
  SHARE_SEARCH_ERROR: 'SHARE_SEARCH_ERROR',
  SHARE_SEARCH_SUCCESS: 'SHARE_SEARCH_SUCCESS',
  SHOW_SEARCH_MEMBERS: 'SHOW_SEARCH_MEMBERS',
  SHOW_SEARCH_MEMBERS_ERROR: 'SHOW_SEARCH_MEMBERS_ERROR',
  SHOW_SHARE_SEARCH: 'SHOW_SHARE_SEARCH',
  UPDATE_CURRENT_SEARCH_PERMISSIONS: 'UPDATE_CURRENT_SEARCH_PERMISSIONS',
  UPDATE_SEARCH_MEMBER_PERMISSIONS: 'UPDATE_SEARCH_MEMBER_PERMISSIONS',
  UPDATE_SEARCH_MEMBER_PROPERTIES: 'UPDATE_SEARCH_MEMBER_PROPERTIES',
  UPDATE_SHARE_SEARCH_PROPERTIES: 'UPDATE_SHARE_SEARCH_PROPERTIES',
};

export const searchCreatorPermissions = {
  SECURITY: 'can_manage_perms',
};

export const searchPermissionGroups = {
  OWNER: Object.values(searchPermissions),
  EDITOR: [searchPermissions.UPDATE],
  OBSERVER: [],
};

export const searchPermissionGroupNames = {
  OWNER: 'OWNER',
  EDITOR: 'EDITOR',
  OBSERVER: 'OBSERVER',
};

export default searchSharingActions;
